import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs/operators';

import {EVENT_BUS} from '@shared/domain/tokens/event-bus.token';
import {AccountModeChangedEvent} from '@shared/application/events/account/account-mode-changed.event';
import {ACCOUNT_MODE} from '@core/entities/account/account-modes/enum/account-mode.enum';
import {WalletRemovedEvent} from '@platform/event-bus/domain/events/wallet/wallet-removed.event';

@Injectable({providedIn: 'root'})
export class PlatformOnWalletRemovedSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.eventBus
      .ofType(WalletRemovedEvent)
      .pipe(
        tap(() => this.eventBus.publish(new AccountModeChangedEvent(ACCOUNT_MODE.default))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
